import { render, staticRenderFns } from "./changeWx.vue?vue&type=template&id=7cd688d1&scoped=true&"
import script from "./changeWx.vue?vue&type=script&lang=js&"
export * from "./changeWx.vue?vue&type=script&lang=js&"
import style0 from "./changeWx.vue?vue&type=style&index=0&id=7cd688d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd688d1",
  null
  
)

component.options.__file = "changeWx.vue"
export default component.exports